<mat-card class="p-0">
  <form *ngIf="itemForm" [formGroup]="itemForm">
    <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="16px" class="form-container">
      <!-- Botões de Ação Superior -->
      <div fxFlex="100" fxFlex.gt-md="50" fxLayout="row wrap" fxLayoutGap="8px" class="action-toolbar">
        <button mat-raised-button color="accent" (click)="$event.preventDefault(); close()">
          <mat-icon>arrow_back</mat-icon>
          <ng-container *ngIf="!layoutConf.isMobile">{{ "VOLTAR" | translate }}</ng-container>
        </button>
        <button mat-raised-button color="primary" cdkFocusInitial [matTooltip]="'Salvar Cadastro'" #btnSaveRef="matButton"
          (click)="save(); $event.preventDefault()">
          <mat-icon>save</mat-icon>
          <ng-container *ngIf="!layoutConf.isMobile">{{ "SAVE" | translate }}</ng-container>
        </button>
        <button mat-raised-button color="primary" [matMenuTriggerFor]="menu" aria-label="Mais Opções">
          <mat-icon>more_vert</mat-icon>
          <ng-container *ngIf="!layoutConf.isMobile">Mais Opções</ng-container>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="openEnderecosPopUp(cadastro); $event.preventDefault();">
            <mat-icon>edit_location</mat-icon> Endereços
          </button>
          <button mat-menu-item (click)="openVendedoresPopUp(cadastro); $event.preventDefault();">
            <mat-icon>group</mat-icon> Vendedores/Representantes
          </button>
          <button mat-menu-item (click)="openMovtoPopUp(cadastro); $event.preventDefault();">
            <mat-icon>storage</mat-icon> Movimentações
          </button>
          <button mat-menu-item (click)="openAnaliseCreditoPopUp(cadastro); $event.preventDefault();">
            <mat-icon>assessment</mat-icon> Análise de Crédito
          </button>
          <button mat-menu-item (click)="openAnexoUploadListPopUp(cadastro); $event.preventDefault();">
            <mat-icon>attachment</mat-icon> Anexos
          </button>
          <button mat-menu-item *ngIf="jwtAuthService.isAuthorized('ROLE_ROOT')"
            (click)="openWebPopUp(cadastro); $event.preventDefault();">
            <mat-icon>public</mat-icon> Web
          </button>
        </mat-menu>
      </div>

      <!-- Conteúdo Principal -->
      <div fxFlex="100">
        <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="16px" class="tab-content">
              <!-- Dados Básicos -->
              <mat-card fxFlex="100" class="section-card">
                <mat-card-title>Cadastro - Dados Básicos</mat-card-title>
                <mat-card-content>
                  <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="16px">
                    <div fxFlex="15" fxFlex.lt-md="100">
                      <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Código</mat-label>
                        <input matInput type="text" formControlName="codigo" />
                        <mat-error *ngIf="itemForm.controls['codigo'].hasError('required') && itemForm.controls['codigo'].touched">
                          Código não informado
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div fxFlex="35" fxFlex.lt-md="100">
                      <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Grupo</mat-label>
                        <mat-select formControlName="cadCadastroGrupo" (selectionChange)="onSelectionChangeGrupo($event)" required
                          [compareWith]="objectComparisonFunction">
                          <mat-option *ngFor="let cadCadastroGrupo of grupos" [value]="cadCadastroGrupo">
                            {{ cadCadastroGrupo.id.toString().padStart(3, '0') + ' - ' + cadCadastroGrupo?.descricao }}
                          </mat-option>
                        </mat-select>
                        <mat-error *ngIf="itemForm.controls['cadCadastroGrupo'].hasError('required') && itemForm.controls['cadCadastroGrupo'].touched">
                          Grupo não informado
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div fxFlex="20" fxFlex.lt-md="100">
                      <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Data de Cadastro</mat-label>
                        <input matInput [value]="cadastro?.issueDate | date:'dd/MM/yyyy'" disabled />
                      </mat-form-field>
                    </div>

                    <div fxFlex="15" fxFlex.lt-md="100">
                      <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Pessoa</mat-label>
                        <mat-select formControlName="pessoa">
                          <mat-option value="Juridica">Jurídica</mat-option>
                          <mat-option value="Fisica">Física</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div fxFlex="25" fxFlex.lt-md="100">
                      <mat-form-field appearance="outline" class="full-width" *ngIf="itemForm.value.pessoa === 'Juridica'">
                        <mat-label>CNPJ</mat-label>
                        <input [imask]="maskCnpj" matInput type="text" formControlName="cpfCnpj" />
                        <mat-error *ngIf="itemForm.controls['cpfCnpj'].hasError('required') && itemForm.controls['cpfCnpj'].touched">
                          CNPJ é obrigatório
                        </mat-error>
                        <mat-error *ngIf="itemForm.controls['cpfCnpj'].hasError('validaCpfCnpj') && itemForm.controls['cpfCnpj'].touched">
                          CNPJ inválido
                        </mat-error>
                      </mat-form-field>
                      <mat-form-field appearance="outline" class="full-width" *ngIf="itemForm.value.pessoa !== 'Juridica'">
                        <mat-label>CPF</mat-label>
                        <input [imask]="maskCpf" matInput type="text" formControlName="cpfCnpj" />
                        <mat-error *ngIf="itemForm.controls['cpfCnpj'].hasError('required') && itemForm.controls['cpfCnpj'].touched">
                          CPF é obrigatório
                        </mat-error>
                        <mat-error *ngIf="itemForm.controls['cpfCnpj'].hasError('validaCpfCnpj') && itemForm.controls['cpfCnpj'].touched">
                          CPF inválido
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div fxFlex="30" fxFlex.lt-md="100" *ngIf="itemForm.value.pessoa === 'Juridica'" class="consulta-buttons-row">
                      <button-loading color="primary" type="button" [loading]="isSearchingWs$ | async"
                        [loadingText]="('WAITING' | translate) + (counter$ | async) + ' Seg.'"
                        (click)="consultaCNPJ(itemForm.controls['cpfCnpj'].value)" [matTooltip]="'Pesquisa CNPJ na Receita WS'">
                        <ng-container *ngIf="(counter$ | async) as counter">
                          <ng-container *ngIf="!(counter > 0 && counter < 20)">
                            <mat-icon>search</mat-icon> {{ "SEARCH_CNPJ_WS" | translate }}
                          </ng-container>
                          <ng-container *ngIf="counter > 0 && counter < 20">
                            Aguarde: {{ counter }} Seg.
                          </ng-container>
                        </ng-container>
                      </button-loading>

                      <button-loading color="primary" type="button" *ngIf="itemForm.value.cadMun" [loading]="isSearchingSefaz" [loadingText]="('SEARCHING' | translate)"
                        (click)="selecionaUF()" [matTooltip]="'Pesquisa CNPJ na SEFAZ'">
                        <mat-icon>search</mat-icon> {{ "SEARCH_CNPJ_SEFAZ" | translate }} ({{ itemForm.value.uf }})
                      </button-loading>
                    </div>
                    <div fxFlex="50" fxFlex.lt-md="100" *ngIf="cnpjReceitaResult || cnpjReceitaResult2">
                      <div class="test-result-header compact">
                        <div class="test-result-title">Resultado Pesquisa Receita Estadual</div>
                        <span class="test-badge" [ngClass]="getConsultaSefazBadgeClass()">
                          <mat-icon>{{ getConsultaSefazBadgeIcon() }}</mat-icon>
                          {{ getConsultaSefazBadgeLabel() }}
                        </span>
                      </div>
                      <div class="test-result-card compact" [ngClass]="getConsultaSefazBadgeClass()">
                        <p class="test-result-message compact">{{ getConsultaSefazMessageCompact() }}</p>
                      </div>
                    </div>
                    <div fxFlex="50" fxFlex.lt-md="100">
                      <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Nome/Razão Social</mat-label>
                        <input [imask]="maskUpper" matInput type="text" formControlName="razaoSocial" (blur)="preencheNomeFantasia()" />
                        <mat-error *ngIf="itemForm.controls['razaoSocial'].hasError('required') && itemForm.controls['razaoSocial'].touched">
                          Nome/Razão Social é obrigatório
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div fxFlex="50" fxFlex.lt-md="100">
                      <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Nome Fantasia</mat-label>
                        <input [imask]="maskUpper" matInput type="text" formControlName="nomeFantasia" />
                        <mat-error *ngIf="itemForm.controls['nomeFantasia'].hasError('required') && itemForm.controls['nomeFantasia'].touched">
                          Nome Fantasia é obrigatório
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <!-- Campos antes em "Dados Adicionais" agora em "Cadastro - Dados Básicos" abaixo do Nome Fantasia -->
                    <div fxFlex="25" fxFlex.lt-md="100" *ngIf="!itemForm.value.produtor">
                      <mat-form-field appearance="outline" class="full-width">
                        <mat-label>{{ itemForm.value.pessoa === 'Juridica' ? 'Inscrição Estadual' : 'RG' }}</mat-label>
                        <input [imask]="maskUpper" matInput type="text" formControlName="rgInscricao" value="ISENTO" />
                        <mat-error *ngIf="itemForm.controls['rgInscricao'].hasError('required') && itemForm.controls['rgInscricao'].touched">
                          RG/Inscrição é obrigatório
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div fxFlex="15" fxFlex.lt-md="100" *ngIf="itemForm.value.produtor">
                      <mat-form-field appearance="outline" class="full-width">
                        <mat-label>{{ itemForm.value.pessoa === 'Juridica' ? 'Inscrição Estadual' : 'RG' }}</mat-label>
                        <input [imask]="maskUpper" matInput type="text" formControlName="rgInscricao" value="ISENTO" />
                        <mat-error *ngIf="itemForm.controls['rgInscricao'].hasError('required') && itemForm.controls['rgInscricao'].touched">
                          RG/Inscrição é obrigatório
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div fxFlex="15" fxFlex.lt-md="100" *ngIf="itemForm.value.produtor">
                      <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Inscrição CAD-PRO</mat-label>
                        <input [imask]="maskUpper" matInput type="text" formControlName="inscricaoCadPro" />
                        <mat-error *ngIf="itemForm.controls['inscricaoCadPro'].hasError('required') && itemForm.controls['inscricaoCadPro'].touched">
                          Inscrição CAD-PRO é obrigatória
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div fxFlex="15" fxFlex.lt-md="100">
                      <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Contribuinte ICMS</mat-label>
                        <mat-select formControlName="contribuinteIcms">
                          <mat-option value="Sim">Sim</mat-option>
                          <mat-option value="Nao">Não</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div fxFlex="20" fxFlex.lt-md="100">
                      <mat-form-field appearance="outline" class="full-width">
                        <mat-label>{{ itemForm.value.pessoa === 'Juridica' ? 'Data da Fundação' : 'Data de Nascimento' }}</mat-label>
                        <input matInput [matDatepicker]="picker" formControlName="dataNasc" />
                        <mat-hint>DD/MM/YYYY</mat-hint>
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker startView="month"></mat-datepicker>
                      </mat-form-field>
                    </div>
                    <div fxFlex="30" fxFlex.lt-md="100">
                      <mat-form-field appearance="outline" class="full-width">
                        <mat-label>CNH</mat-label>
                        <input matInput type="text" formControlName="cnh" />
                      </mat-form-field>
                    </div>

                    <div fxFlex="100" *ngIf="itemForm.hasError('atLeastOneId') && (itemForm.controls['cpfCnpj']?.touched || itemForm.controls['rgInscricao']?.touched || itemForm.controls['inscricaoCadPro']?.touched)">
                      <mat-error>Informe pelo menos um identificador válido (CPF/CNPJ, RG ou Inscrição CAD-PRO)</mat-error>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>

              <!-- Classificação do Cadastro -->
              <mat-card fxFlex="100" class="section-card">
                <mat-card-title>Classificação do Cadastro</mat-card-title>
                <mat-card-content>
                  <div class="classificacao-grid">
                    <div>
                      <mat-slide-toggle formControlName="cliente">Cliente</mat-slide-toggle>
                    </div>
                    <div>
                      <mat-slide-toggle formControlName="fornecedor">Fornecedor</mat-slide-toggle>
                    </div>
                    <div>
                      <mat-slide-toggle formControlName="vendedor">Vendedor</mat-slide-toggle>
                    </div>
                    <div>
                      <mat-slide-toggle formControlName="produtor">Produtor</mat-slide-toggle>
                    </div>
                    <div>
                      <mat-slide-toggle formControlName="funcionario">Funcionário</mat-slide-toggle>
                    </div>
                    <div>
                      <mat-slide-toggle formControlName="trabalhador">Trabalhador</mat-slide-toggle>
                    </div>
                    <div>
                      <mat-slide-toggle formControlName="transportador">Transportadora</mat-slide-toggle>
                    </div>
                    <div>
                      <mat-slide-toggle formControlName="motorista">Motorista</mat-slide-toggle>
                    </div>
                    <div>
                      <mat-slide-toggle formControlName="pontoAtendimento">Ponto de Atendimento</mat-slide-toggle>
                    </div>
                    <div>
                      <mat-slide-toggle formControlName="orgao">Órgão/Departamento</mat-slide-toggle>
                    </div>
                    <div>
                      <mat-slide-toggle formControlName="sindicato">Sindicato</mat-slide-toggle>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>

              <!-- Contato -->
              <mat-card fxFlex="100" class="section-card">
                <mat-card-title>Contato</mat-card-title>
                <mat-card-content>
                  <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="16px">
                    <div fxFlex="20" fxFlex.lt-md="100">
                      <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Telefone Fixo</mat-label>
                        <input [imask]="maskFone" matInput type="text" formControlName="telefone1" />
                        <mat-hint>Informe DDD + número</mat-hint>
                        <mat-error *ngIf="itemForm.controls['telefone1'].hasError('required') && itemForm.controls['telefone1'].touched">
                          Telefone é obrigatório
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div fxFlex="20" fxFlex.lt-md="100">
                      <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Celular</mat-label>
                        <input [imask]="maskFone" matInput type="text" formControlName="celular" />
                        <mat-hint>Informe DDD + número</mat-hint>
                        <mat-error *ngIf="itemForm.controls['celular'].hasError('required') && itemForm.controls['celular'].touched">
                          Celular é obrigatório
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div fxFlex="40" fxFlex.lt-md="100">
                      <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Email</mat-label>
                        <input [imask]="maskEmail" matInput type="email" formControlName="email" />
                        <mat-hint>Ex.: usuario@empresa.com</mat-hint>
                        <mat-error *ngIf="itemForm.controls['email'].hasError('email') && itemForm.controls['email'].touched">
                          E-mail em formato inválido
                        </mat-error>
                        <mat-error *ngIf="itemForm.controls['email'].hasError('required') && itemForm.controls['email'].touched">
                          E-mail é obrigatório
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>

              <mat-card fxFlex="100" class="section-card">
                <mat-card-title>Análise de Crédito</mat-card-title>
                <mat-card-content>
                  <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="16px" fxLayoutAlign="start center">
                    <div fxFlex="30" fxFlex.lt-md="100">
                      <mat-slide-toggle formControlName="chkAnaliseCredito">Checar Análise</mat-slide-toggle>
                    </div>
                    <div fxFlex="25" fxFlex.lt-md="100">
                      <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Limite de Crédito</mat-label>
                        <input
                          matInput
                          type="text"
                          formControlName="limiteCredito"
                          currencyMask
                          [options]="{ prefix: '', align: 'right', thousands: '.', decimal: ',', precision: 2, allowNegative: false }" />
                      </mat-form-field>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>

              <!-- Endereço -->
              <mat-card fxFlex="100" class="section-card">
                <mat-card-title>Endereço</mat-card-title>
                <mat-card-content>
                  <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="16px">
                    <div fxFlex="15" fxFlex.lt-md="100">
                      <mat-form-field appearance="outline" class="full-width">
                        <mat-label>CEP</mat-label>
                        <input [imask]="maskCep" matInput type="text" formControlName="cep" (blur)="consultaCep($event.target.value)" />
                      </mat-form-field>
                    </div>
                    <div fxFlex="25" fxFlex.lt-md="100">
                      <mat-form-field appearance="outline" class="full-width" *ngIf="!(isSearchingCidade$ | async)">
                        <mat-label>Cidade</mat-label>
                        <mat-select formControlName="cadMun" (selectionChange)="onSelectionChange($event)">
                          <mat-option>
                            <ngx-mat-select-search formControlName="searchCidade" placeholderLabel="Pesquisar Cidade"
                              noEntriesFoundLabel="Cidade não encontrada" [searching]="searching"></ngx-mat-select-search>
                          </mat-option>
                          <mat-option *ngFor="let cadMun of cidades$ | async" [value]="cadMun">
                            {{ cadMun?.municipio?.trim() }} - {{ cadMun?.uf?.trim() }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div fxFlex="40" fxFlex.lt-md="100">
                      <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Endereço</mat-label>
                        <input [imask]="maskUpper" matInput type="text" formControlName="endereco" />
                        <mat-error *ngIf="itemForm.controls['endereco'].hasError('required') && itemForm.controls['endereco'].touched">
                          Endereço é obrigatório
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div fxFlex="15" fxFlex.lt-md="100">
                      <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Número</mat-label>
                        <input [imask]="maskUpper" matInput type="text" formControlName="numero" />
                      </mat-form-field>
                    </div>
                    <div fxFlex="20" fxFlex.lt-md="100">
                      <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Bairro</mat-label>
                        <input [imask]="maskUpper" matInput type="text" formControlName="bairro" />
                      </mat-form-field>
                    </div>
                    <div fxFlex="25" fxFlex.lt-md="100">
                      <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Complemento</mat-label>
                        <input [imask]="maskUpper" matInput type="text" formControlName="complemento" />
                      </mat-form-field>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>

              <!-- Sócio Administrativo -->
              <mat-card fxFlex="100" class="section-card" *ngIf="itemForm.value.pessoa === 'Juridica'">
                <mat-card-title>Sócio Administrativo</mat-card-title>
                <mat-card-content>
                  <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="16px">
                    <div fxFlex="50" fxFlex.lt-md="100">
                      <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Sócio Administrativo</mat-label>
                        <mat-select formControlName="socioAdm" (selectionChange)="onSelectionChangeSocio($event)">
                          <mat-option>
                            <ngx-mat-select-search formControlName="searchSocio" placeholderLabel="Pesquisar Sócio"
                              noEntriesFoundLabel="Sócio não encontrado" [searching]="searching"></ngx-mat-select-search>
                          </mat-option>
                          <mat-option *ngFor="let s of socios" [value]="s">
                            {{ s?.codigo?.toString()?.padStart(9, '0') + "-" + s?.razaoSocial }}
                          </mat-option>
                        </mat-select>
                        <mat-error *ngIf="itemForm.controls['socioAdm'].hasError('required') && itemForm.controls['socioAdm'].touched">
                          Sócio Administrativo é obrigatório
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div fxFlex="50" fxFlex.lt-md="100">
                      <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Endereço do Sócio</mat-label>
                        <mat-select formControlName="socioAdmEndereco" [compareWith]="objectComparisonFunction">
                          <mat-option *ngFor="let e of socioEnderecos" [value]="e">
                            <div class="endereco-option-wrap">
                              <div class="endereco-option-main">
                                {{ e?.endereco?.trim() + ',' + e?.numero?.trim() + '/' + e?.cadMun?.municipio?.trim() + '-' + e?.cadMun?.uf }}
                              </div>
                              <div class="class-tags endereco-option-tags">
                                <span class="tag tag-entrega" *ngIf="e?.entrega">Entrega</span>
                                <span class="tag tag-cobranca" *ngIf="e?.cobranca">Cobrança</span>
                                <span class="tag tag-padrao" *ngIf="e?.padrao">Padrão</span>
                              </div>
                            </div>
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>

              <!-- Observação -->
              <mat-card fxFlex="100" class="section-card">
                <mat-card-title>Observação</mat-card-title>
                <mat-card-content>
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Observação</mat-label>
                    <textarea matInput formControlName="obs" rows="4"></textarea>
                  </mat-form-field>
                </mat-card-content>
              </mat-card>
        </div>

        <mat-card class="section-card" *ngIf="cnpjReceitaResult || cnpjReceitaWsResult">
          <mat-card-title>Resultado das consultas</mat-card-title>
          <mat-card-content>
            <div fxLayout="column" fxLayoutGap="16px" class="tab-content test-result-wrap">
              <div fxFlex="100" *ngIf="cnpjReceitaWsResult">
                <div class="test-result-header">
                  <div class="test-result-title">Resultado da pesquisa em Receita WS</div>
                  <span class="test-badge" [ngClass]="getConsultaWsBadgeClass()">
                    <mat-icon>{{ getConsultaWsBadgeIcon() }}</mat-icon>
                    {{ getConsultaWsBadgeLabel() }}
                  </span>
                </div>

                <div class="test-result-card" [ngClass]="getConsultaWsBadgeClass()">
                  <p class="test-result-message">{{ getConsultaWsMessage() }}</p>
                  <details class="tech-details">
                    <summary>Detalhes técnicos</summary>
                    <pre>{{ cnpjReceitaWsResult ?? '' | json }}</pre>
                  </details>
                </div>
              </div>

              <div fxFlex="100" *ngIf="cnpjReceitaResult">
                <div class="test-result-header">
                  <div class="test-result-title">Resultado da pesquisa na Receita Estadual (SEFAZ)</div>
                  <span class="test-badge" [ngClass]="getConsultaSefazBadgeClass()">
                    <mat-icon>{{ getConsultaSefazBadgeIcon() }}</mat-icon>
                    {{ getConsultaSefazBadgeLabel() }}
                  </span>
                </div>

                <div class="test-result-card" [ngClass]="getConsultaSefazBadgeClass()">
                  <p class="test-result-message">{{ getConsultaSefazMessage() }}</p>
                  <details class="tech-details">
                    <summary>Detalhes técnicos</summary>
                    <pre>{{ cnpjReceitaResult ?? '' | json }}</pre>
                  </details>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>

    <!-- Botões Inferiores -->
    <mat-card-actions>
      <div fxFlex="100" class="action-buttons">
        <button mat-raised-button color="primary" [matTooltip]="'Salvar Cadastro'" (click)="save(); $event.preventDefault()">
          <mat-icon>save</mat-icon>
          <ng-container *ngIf="!layoutConf.isMobile">{{ "SAVE" | translate }}</ng-container>
        </button>
      </div>
    </mat-card-actions>
  </form>
</mat-card>